import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { icoChevronRight, icoCogDuo, icoEditFieldDuo, IconsModule } from '../icons';
import { TabSelectableModule } from '../tab-selectable';
import { CardComponent } from './card/card.component';

@NgModule({
  declarations: [CardComponent],
  imports: [CommonModule, IconsModule.withIcons(icoCogDuo, icoChevronRight, icoEditFieldDuo), TabSelectableModule],
  exports: [CardComponent]
})
export class CardModule {}
